// 角色管理 
import http from '../httpConfig'


const table = 'mrbase_sys_role'

// 功能权限树列表
export const func_list = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/role/list-function_role/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 角色权限列表
export const role_list = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/role/list-role/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 角色权限新增
export const role_add = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/role/add-role/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 角色权限修改
export const role_update = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/role/update-role/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 角色权限删除
export const role_del = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/role/delect-role/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 角色权限详情
export const role_info = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/role/find-role/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}